import React, { useEffect } from 'react';
import Iconfont from '@base/lib/Iconfont';
import type { ISearchSuggestInstance } from '@base/snippets/SearchSuggest/useSearchSuggest';
import { useStoreState } from 'base/store';
import { displayCtr, trackElement } from 'base/utils/tracker';
import { useTrans } from 'base/utils/i18n';

export type ISearchSuggestTrackData = {
    relTarget: string;
    module: string;
    targetType: string;
}

type IProps = {
    searchSuggest: ISearchSuggestInstance;
    onSearchCallBack?: (text?: string) => void;
    className?: string;
    moduleTrackData: ISearchSuggestTrackData;
}

const SearchSuggest: React.FC<IProps> = (props) => {
    const {
        searchSuggest: {
            historyList,
            clearHistoryList,
            clearHistoryItem,
            hotList,
            onSearch,
        },
        onSearchCallBack,
        moduleTrackData,
    } = props;
    const { ua: { isPhone } } = useStoreState('rootStore');
    const { t } = useTrans();

    const handleSearch = (text: string) => {
        onSearch?.(text)
        onSearchCallBack?.(text)
    }

    useEffect(() => {
        if (hotList.length > 0) {
            displayCtr(moduleTrackData.module);
        }
    }, [hotList]);

    return (
        <>
            {historyList.length > 0 && (
                <div className="group">
                    <div className="group-title flex flex-middle">
                        <h4 className="flex-1">{t('web_search_history_title')}</h4>
                        <button
                            type="button"
                            className="btn-delete btn-no-style"
                            onClick={clearHistoryList}
                            aria-label={'clear Recently Search'}
                        >
                            <Iconfont className="icon-ashbin"/>
                        </button>
                    </div>
                    <ul role={'group'} className="history-list">
                        {historyList.map(item => (
                            <li
                                key={item}
                                className="history-item"
                                tabIndex={0}
                                role={'button'}
                                onClick={() => handleSearch(item)}
                            >
                                <p className="text">{item}</p>
                                {!isPhone && (
                                    <button
                                        type="button"
                                        aria-label={'clear'}
                                        className="btn-delete btn-no-style"
                                        tabIndex={0}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            clearHistoryItem(item);
                                        }}
                                    >
                                        <Iconfont className="icon-x"/>
                                    </button>
                                )}
                            </li>
                        ))}
                    </ul>
                </div>
            )}

            {hotList.length > 0 && (
                <div role={'group'} className="group" data-t-mod={moduleTrackData.module}>
                    <h4 tabIndex={0} className="group-title flex">{t('web_search_hot_search_title')}</h4>
                    <ul className="hot-list">
                        {hotList.map((item, index) => (
                            <li
                                key={item}
                                className="hot-item"
                                tabIndex={0}
                                role={'button'}
                                data-t-tar={item}
                                data-t-pos={index + 1}
                                // 键盘 tab 时 最后一个元素 onBlur 时 关闭弹窗
                                {...(index + 1 == hotList.length ? { onBlur: onSearchCallBack } : {}) as any}
                                onClick={() => {
                                    handleSearch(item)
                                    trackElement({
                                        action: 'click',
                                        target: item,
                                        position: index + 1,
                                        ...moduleTrackData
                                    })
                                }}
                            >
                                {item}
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </>
    )
}

export default React.memo(SearchSuggest)